import { useState, useRef } from "react";

// Pure array helpers shared by the landing editor (otherSections)
// and the template fill flow (fillSections).

export const moveItem = (arr, from, to) => {
  const next = [...arr];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};

export const removeItem = (arr, index) => arr.filter((_, i) => i !== index);

export const updateItem = (arr, index, patch) =>
  arr.map((item, i) => (i === index ? { ...item, ...patch } : item));

export const addItem = (arr, item) => [...(arr || []), item];

// Native HTML5 drag-and-drop reordering for a list of sections.
// Returns handlers to spread onto the drop target and drag handle.
export function useSectionReorder(sections, setSections) {
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragIndex = useRef(null);

  const handleDragStart = (index) => {
    dragIndex.current = index;
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    const from = dragIndex.current;
    if (from !== null && from !== index) {
      setSections(moveItem(sections, from, index));
    }
    setDragOverIndex(null);
    dragIndex.current = null;
  };

  const handleDragEnd = () => {
    setDragOverIndex(null);
    dragIndex.current = null;
  };

  return { dragOverIndex, handleDragStart, handleDragOver, handleDrop, handleDragEnd };
}
